import index from "./home.vue";
export default index;
